import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Form, Row, Col, Input } from 'antd';
import FormModal from './FormModal'
import FormImport from './FormImport'
import { PAGE_SIZE_DEFAULT } from '../../../constants/appConstant';
@inject('webEDIShipToStore','uiState')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: false,
    importModalVisible: false,
  }
  formRef = React.createRef();
  componentDidMount() {
  }
  handleSearch=()=>{
    const { webEDIShipToStore } = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      webEDIShipToStore.onSearchShipToAction(fieldsValue,1,PAGE_SIZE_DEFAULT)
    }).catch(err => {
    })
  }
  handleCreate=()=>{
    this.setState({
      addModalVisible: true
    })
  }
  handleCancel=()=>{
    this.setState({
      addModalVisible: false
    })
  }
  handleImport=()=>{
    this.setState({
      importModalVisible: true
    })
  }
  handleCancelImport=()=>{
    this.setState({
      importModalVisible: false
    })
  }
  handleExport = () => {
    const { webEDIShipToStore,uiState } = this.props
    const { searchItem } = webEDIShipToStore
    this.formRef.current.validateFields().then(fieldsValue => {
      uiState.onChangeFetchingExport('/china/web/edi/ship/export', searchItem, `pgStore.xlsx`)
    }).catch(err => {
    })
  }
  render() {
    return (
      <>
        <Row>
              <Col span={12}>
                <Form ref={this.formRef} labelCol={{ span: 8 }} initialValues={{index: 0,name: '', key: ''}}>
                  <Row wrap={true} gutter={[10,10]}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12} span={12}>
                      <Form.Item name='shipTo' label="Ship To" labelCol={{span:6}} wrapperCol={{span:18}}
                                 rules={[{ message: 'Please enter Ship To without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) }]}>
                        <Input maxLength={100} placeholder="Please enter ..." allowClear />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Col>
              <Col span={12} style={{textAlign: 'right'}}>
                <Button style={{marginRight: 10}} onClick={this.handleSearch} type='primary'>Search</Button>
                <Button style={{marginRight: 10}} onClick={this.handleCreate} type='primary'>Add</Button>
                <Button style={{marginRight: 10}} onClick={this.handleImport} type='primary'>Import</Button>
                <Button onClick={this.handleExport} type='primary'>Export</Button>
              </Col>
        </Row>
        {this.state.addModalVisible?<FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
        />:null}
        {this.state.importModalVisible?<FormImport
          modalVisible={this.state.importModalVisible}
          handleCancel={this.handleCancelImport}
        />:null}
      </>
    );
  }
}

export default SearchForm;
